<template>
  <div class="bjtjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="报价日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                  :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelLoading"
                @click="exportExcelAll">导出Excel</el-button>
            </el-form-item>
            <el-form-item style="float: right; margin-right: 0;">
              <el-button icon="el-icon-document" @click="openDialog">多订单统计导出</el-button>
            </el-form-item>
          </el-form>

          <div
            style="font-size: 13px; color:#F56C6C; background-color: #fef0f0; border-radius: 5px; padding: 12px 20px; margin-bottom: 20px;">
            <i class="el-icon-info" style="font-size: 16px;" />
            <b style="margin-left: 4px; font-size: 16px;">注意事项</b><br />
            统计数据的报价日期以最终报价时间为节点，驳回再报价的订单以最后一次报价时间为准；如：某订单2025年2月订单报价完成，2025年4月驳回进行重新报价，该订单报价统计时间计为2025年4月，2月统计数据将不会包含该订单。
          </div>

          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  总报价金额组成统计：共 {{ totalPrice4 }} 元，报价金额下单率 {{ xdRate }}%
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table4Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="组成" align="center" width="180"></el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '4')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle4" :option="circleOption4" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <div
              style="font-size: 13px; color:#F56C6C; background-color: #fef0f0; border-radius: 5px; padding: 12px 20px; margin-top: 20px;">
              <i class="el-icon-info" style="font-size: 16px;" />
              <b style="margin-left: 4px; font-size: 16px;">注意事项</b><br />
              总报价金额中减去历史上已报过价的部分，如：某订单在2025年2月完成报价，2025年4月再次进行报价就不会统计进去。
            </div>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">新增报价金额组成统计：共 {{ totalPrice8 }} 元</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table8Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="组成" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle8" :option="circleOption8" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">报价人员业绩统计：共 {{ totalPrice11 }} 元</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table11Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="报价员" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-view" @click="seeBjDetail(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle11" :option="circleOption11" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">拆单人员预估业绩统计：共 {{ totalPrice10 }} 元</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table10Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="拆单员" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="拆单金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="拆单金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle10" :option="circleOption10" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">订单报价数量统计：共 {{ totalPrice5 }} 单</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table5Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="订单类型" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '5')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle5" :option="circleOption5" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">订单报价金额统计：共 {{ totalPrice6 }} 元</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table6Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="订单金额类型" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '6')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle6" :option="circleOption6" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <div
              style="font-size: 13px; color:#F56C6C; background-color: #fef0f0; border-radius: 5px; padding: 12px 20px; margin-top: 20px;">
              <i class="el-icon-info" style="font-size: 16px;" />
              <b style="margin-left: 4px; font-size: 16px;">注意事项</b><br />
              报价时长以用户确认时间到最后一次报价时间为准，如：某订单在3月1号用户确认，2号报价完成，4号用户驳回当日再次报价，将会按照1~4号的天数进行统计。
            </div>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">订单正单报价时长统计：共 {{ totalPrice7 }} 单</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <!-- <el-button icon="el-icon-printer" style="margin-bottom: 10px; float: right;" size="small"
                  :loading="excelLoading" @click="exportExcelOfferTime">导出Excel</el-button> -->
                <el-table :data="table7Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '7')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle7" :option="circleOption7" />
              </el-col>
            </el-row>
            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">订单补单报价时长统计：共 {{ totalPrice71 }} 单</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <!-- <el-button icon="el-icon-printer" style="margin-bottom: 10px; float: right;" size="small"
                  :loading="excelLoading" @click="exportExcelOfferTime">导出Excel</el-button> -->
                <el-table :data="table71Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '7')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle71" :option="circleOption71" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  品类报价统计：共 {{ totalPrice }} 元<b style="margin-left: 4px; font-size: 16px; color:#F56C6C;">（非更改单）</b>
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="tableData" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="品类" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '1')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle" :option="circleOption" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  工艺报价统计：共 {{ totalPrice2 }} 元<b style="margin-left: 4px; font-size: 16px; color:#F56C6C;">（非更改单）</b>
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table2Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="工艺" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '2')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle2" :option="circleOption2" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">更改单报价统计：共 {{ totalPrice3 }} 元</div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="table3Data" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="类型" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="报价金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row, '3')" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle3" :option="circleOption3" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                  <el-form-item label="统计年份">
                    <YearPicker v-model="searchForm.years" style="width: 300px" value-format="yyyy" format="yyyy年">
                    </YearPicker>
                  </el-form-item>
                  <el-form-item label="组织">
                    <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable>
                      <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                        :value="item.groupid" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" @click="getAvgData">搜索</el-button>

                  </el-form-item>
                </el-form>
              </el-col>

              <el-col :span="24" style="padding-top: 10px" v-loading="avgLoading">
                <el-button icon="el-icon-printer" style="float: right; margin: 8px;" size="small"
                  :loading="excelLoading" @click="exportExcelOfferAvgPrice(1)">导出Excel1</el-button>
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; text-align: center;">
                  {{ searchForm.years.length == 2 ? searchForm.years[0] + ' ~ ' + searchForm.years[1] : '' }}年度{{ searchForm.brand }}品牌家装正单报价均值统计表
                </div>
                <el-table :data="avgTableData" stripe max-height="500px" style="width: 100%">
                  <el-table-column prop="year" label="年份" align="center" fixed="left" width="100"></el-table-column>
                  <el-table-column v-for="i in 13" :key="i" :label="i == 13 ? '总计' : i + '月'" align="center"
                    min-width="300" :fixed="i == 13 ? 'right' : false">
                    <el-table-column label="家装正单总报价金额" align="center" width="120" :fixed="i == 13 ? 'right' : false">
                      <template slot-scope="scope">{{ scope.row.list[i - 1].totalPrice }}</template>
                    </el-table-column>
                    <el-table-column label="终端地址数量" align="center" width="80" :fixed="i == 13 ? 'right' : false">
                      <template slot-scope="scope">{{ scope.row.list[i - 1].count }}</template>
                    </el-table-column>
                    <el-table-column label="均价" align="center" width="100" :fixed="i == 13 ? 'right' : false">
                      <template slot-scope="scope">{{ scope.row.list[i - 1].avgPrice }}</template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>

              <el-col :span="24" style="padding-top: 40px" v-loading="avgLoading">
                <!-- <el-button icon="el-icon-printer" style="float: right; margin: 8px;" size="small"
                  :loading="excelLoading" @click="exportExcelOfferAvgPrice(2)">导出Excel2</el-button> -->
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; text-align: center;">
                  {{ searchForm.years.length == 2 ? searchForm.years[0] + ' ~ ' + searchForm.years[1] : '' }}年度{{ searchForm.brand }}品牌家装正单经销商报价均值统计表
                </div>
                <el-table :data="delAvgTableData" stripe max-height="500px" style="width: 100%">
                  <el-table-column prop="dealer" label="经销商" align="center" min-width="140"></el-table-column>
                  <el-table-column v-for="year in searchYears" :key="year" :label="year + '年'" align="center"
                    min-width="300">
                    <el-table-column label="家装正单总报价金额" align="center" min-width="120">
                      <template slot-scope="scope">
                        {{ scope.row[`${year}`] ? scope.row[`${year}`].totalPrice : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="终端地址数量" align="center" min-width="80">
                      <template slot-scope="scope">
                        {{ scope.row[`${year}`] ? scope.row[`${year}`].count : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="均价" align="center" min-width="100">
                      <template slot-scope="scope">
                        {{ scope.row[`${year}`] ? scope.row[`${year}`].avgPrice : '' }}
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>

              <el-col :span="24" style="padding-top: 40px" v-loading="avgLoading">
                <!-- <el-button icon="el-icon-printer" style="float: right; margin: 8px;" size="small"
                  :loading="excelLoading" @click="exportExcelOfferAvgPrice(3)">导出Excel3</el-button> -->
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; text-align: center;">
                  {{ searchForm.years.length == 2 ? searchForm.years[0] + ' ~ ' + searchForm.years[1] : '' }}年度{{ searchForm.brand }}品牌色板报价金额统计表
                </div>
                <el-table :data="swatchAvgTableData" stripe max-height="500px" style="width: 100%">
                  <el-table-column prop="year" label="年份" align="center" fixed="left" width="80"></el-table-column>
                  <el-table-column prop="swatch" label="色板名称" align="center" fixed="left" width="100"></el-table-column>
                  <el-table-column v-for="i in 13" :key="i" :label="i == 13 ? '总计' : i + '月 报价金额'" align="center"
                    width="120" :fixed="i == 13 ? 'right' : false">
                    <template slot-scope="scope">{{ scope.row.list[i - 1].totalPrice }}</template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="viewType + ' - ' + viewTitle" :visible.sync="viewVisible" width="80%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <div style="height:40px">
          <span style="color:#99a9bf">{{ viewType }}：</span>
          <span style="font-weight: 500">{{ viewName }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价日期：</span>
          <span style="">{{ viewTime }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价金额：</span>
          <span style="color:#409EFF;font-weight: 500;">{{ viewAmount }}</span>
          <el-button icon="el-icon-printer" style="float: right" size="small" :loading="excelLoading"
            @click="exportExcel">导出Excel</el-button>
        </div>

        <el-table :data="viewData" v-loading="viewLoading" size="small" style="width: 100%;border:1px solid #EBEEF5;"
          height="442">
          <el-table-column prop="ordernum" label="订单号" align="center" width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="生产单号" width="90" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF"
                v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
              <span style="font-weight: 500;color:#999999"
                v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
            </template>
          </el-table-column>
          <el-table-column label="经销商" width="120" align="center" prop="delname" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="订单类型" align="center" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type===0">正单</span>
              <span v-if="scope.row.type===1">客改单</span>
              <span v-if="scope.row.type===2">增补单</span>
              <span v-if="scope.row.type===3">色板单</span>
              <span v-if="scope.row.type===4">售后单</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="详细地址" min-width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报价时间" width="160" align="center" prop="time" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报价金额" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.amount}}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination v-if="viewPage.total>0" style="margin-top:10px;" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="viewPage.currentPage" :page-sizes="[10, 20, 50]"
          :page-size="viewPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="viewPage.total">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="多订单统计导出" :visible.sync="dialogVisible" width="520px"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding: 10px 20px 25px 20px">
        <div>模板文件下载：<a style="color:#20a0ff" href="https://www.mulu.life/efile//upload/temp/%E8%AE%A2%E5%8D%95%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls" target="_blank">订单编号导入模板.xls</a></div>
        <SingleFile style="margin-top: 10px;" v-model="order_fileid" :accept="'.xls'" :tip="'只能上传Excel，文件上传后请点击确认导出'" />
        <el-button style="margin-top: 20px;" type="primary" size="medium" icon="el-icon-finished"
          :loading="excelLoading" :disabled="!order_fileid" @click="confirmExport">确认导出面积统计结果</el-button>
        <el-button style="margin-top: 20px;" type="success" size="medium" icon="el-icon-finished"
          :loading="excelLoading" :disabled="!order_fileid" @click="confirmExport2">确认导出金蝶销售订单模板</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="viewTitle2" :visible.sync="orderVisible2" width="80%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <el-table
          :data="orderList2"
          v-loading="orderLoading2"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="60vh">
          <el-table-column
            label="订单号"
            width="130"
            align="center"
            fixed
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.orderNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="生产单号" width="90" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF" v-if="scope.row.prodNum">{{scope.row.prodNum}}</span>
              <span style="font-weight: 500;color:#999999" v-else>N/A</span>
            </template>
          </el-table-column>
          <el-table-column label="经销商" width="150" align="center" prop="dealerName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="订单类型" align="center" prop="orderType" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.orderType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="详细地址" min-width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报价时间" width="170" align="center" prop="time" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报价金额" width="130" align="center" prop="amount" sortable show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.amount}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getOfferCraftsAnalysis,
    getOfferCraftsAnalysisDetail,
    getOfferAvgPrice,
    getOfferAnalysisOrderList,
    exportOfferAnalysisOrderListExcel,
    excelOfferCraftsAnalysis,
    excelOfferTime,
    getGroupInfoByUser,
    getTypeArea
  } from '@/api/erp'

  import axios from 'axios'

  import GraphicsChart from '@/components/Charts/GraphicsChart'
  import YearPicker from '@/components/YearPicker'
  import SingleFile from '@/components/upload/SingleFile'

  import {
    getGroupReport
  } from '@/api/pub'

  export default {
    name: 'bjtjfx',
    components: {
      GraphicsChart,
      YearPicker,
      SingleFile,
    },
    data() {
      return {
        loading: false,
        tableData: [],
        table2Data: [],
        table3Data: [],
        table4Data: [],
        table5Data: [],
        table6Data: [],
        table7Data: [],
        table71Data: [],
        table8Data: [],
        table9Data: [],
        table10Data: [],
        table11Data: [],

        totalPrice: 0,
        totalPrice2: 0,
        totalPrice3: 0,
        totalPrice4: 0,
        totalPrice5: 0,
        totalPrice6: 0,
        totalPrice7: 0,
        totalPrice71: 0,
        totalPrice8: 0,
        totalPrice9: 0,
        totalPrice10: 0,
        totalPrice11: 0,

        xdRate: 0,

        avgTableData: [],
        delAvgTableData: [],
        swatchAvgTableData: [],
        avgLoading: false,

        searchForm: {
          search: '',
          brand: '',
          time: [],
          years: [],
          group: null
        },
        groupList: [],

        circleOption: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption2: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption3: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption4: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption5: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption6: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption7: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption71: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption8: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption9: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption10: {
          title: false,
          credits: {
            enabled: false
          }
        },
        circleOption11: {
          title: false,
          credits: {
            enabled: false
          }
        },

        viewTitle: '',
        viewVisible: false,
        viewAmount: 0,
        viewTime: '',
        viewType: '品类',
        viewName: '',
        excelLoading: false,
        viewData: [],
        viewLoading: [],
        viewPage: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

        viewTitle2: '',
        orderLoading2: false,
        orderVisible2: false,
        orderList2: [],

        group: {
          dBrand: 1
        },

        dialogVisible: false,
        order_fileid: '',
        excelLoading: false,
      }
    },
    computed: {
      user: getUser,
      searchYears() {
        let years = []
        if (this.searchForm.years && this.searchForm.years.length == 2) {
          const s_y = this.searchForm.years[0]
          const e_y = this.searchForm.years[1]
          for (let i = e_y; i >= s_y; i--) {
            years.push(i + '')
          }
        }
        return years
      },
    },
    created() {
      getGroupInfoByUser({
        groupid: this.user.dGroupid
      }).then(response => {
        this.group = response.data
      });

      this.searchForm.group = this.user.dGroupid
      this.searchForm.brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
      this.getGroupList()

      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time.push(year + '-' + month + '-01')
      this.searchForm.time.push(year + '-' + month + '-' + day)
      this.searchForm.years = [year + '', year + '']

      this.getData()
      this.getAvgData()
    },
    methods: {
      openDialog() {
        this.order_fileid = ''
        this.dialogVisible = true
      },
      closeDialog() {
        this.dialogVisible = false
        this.order_fileid = ''
      },
      confirmExport() {
        if (!this.excelLoading) {
          this.excelLoading = true
          const data = {
            fileid: this.order_fileid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          getTypeArea(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                    this.closeDialog()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },
      confirmExport2() {
       if (!this.excelLoading) {
         this.excelLoading = true
         const data = {
           fileid: this.order_fileid
         }
         this.$message({
           message: '数据正在导出，请稍候'
         })
         axios({
           method: 'post',
           url: process.env.VUE_APP_BASE_API + '/api/jd',
           params: data,
           responseType: 'blob', // 表明返回服务器返回的数据类型
           headers: {
             'Content-Type': 'application/json'
           }
         }).then(res => { // 处理返回的文件流
           this.excelLoading = false
           const blob = new Blob([res.data]);
           const fileName = '金蝶销售订单导入模板-' + new Date().getTime() + '.xlsx';
           const elink = document.createElement('a');
           elink.download = fileName;
           elink.style.display = 'none';
           elink.href = URL.createObjectURL(blob);
           document.body.appendChild(elink);
           elink.click();
           URL.revokeObjectURL(elink.href);
           document.body.removeChild(elink);

           this.closeDialog()
         }).catch(err => {
           this.excelLoading = false
           this.$message({
             type: 'error',
             message: '导出失败，请稍候再试'
           })
         });
       }
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          group: this.searchForm.group,
          keyword: this.searchForm.search,
          startTime: startTime,
          endTime: endTime,
          type: 1,
          userid: this.user.dUserid
        }
        this.loading = true
        getOfferCraftsAnalysis(data).then(response => {
          const data = response.data || {}

          this.totalPrice = data.normalTotal || 0
          this.tableData = data.normalTable || []
          this.initCharts(this.tableData, '1')

          this.totalPrice2 = data.normalTotal || 0
          this.table2Data = data.craftsTable || []
          this.initCharts(this.table2Data, '2')

          this.totalPrice3 = data.cTotal || 0
          this.table3Data = data.changeTable || []
          this.initCharts(this.table3Data, '3')

          this.totalPrice4 = data.allTotal || 0
          this.table4Data = data.consistTable || []
          this.initCharts(this.table4Data, '4')

          this.totalPrice5 = data.totalNum || 0
          this.table5Data = data.orderTypes || []
          this.initCharts(this.table5Data, '5')

          this.totalPrice6 = data.allTotal || 0
          this.table6Data = data.orderTypeList || []
          this.initCharts(this.table6Data, '6')

          this.totalPrice7 = data.zNum || 0
          this.table7Data = data.zBjDays || []
          this.initCharts(this.table7Data, '7')

          this.totalPrice71 = data.bNum || 0
          this.table71Data = data.bBjDays || []
          this.initCharts(this.table71Data, '71')

          this.totalPrice8 = data.financeTotal || 0
          this.table8Data = data.financeList || []
          this.initCharts(this.table8Data, '8')

          this.totalPrice10 = data.clientcom || 0
          this.table10Data = data.splitList || []
          this.initCharts(this.table10Data, '10')

          this.totalPrice11 = data.clientcom || 0
          this.table11Data = data.offerList || []
          this.initCharts(this.table11Data, '11')

          this.xdRate = data.xdRate || 0
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      getAvgData() {
        if (this.avgLoading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startYear = ''
        let endYear = ''
        if (this.searchForm.years !== null && this.searchForm.years.length === 2) {
          startYear = this.searchForm.years[0]
          endYear = this.searchForm.years[1]
        }
        const data = {
          group: this.searchForm.group,
          startYear: startYear,
          endYear: endYear,
          userid: this.user.dUserid
        }
        this.avgLoading = true
        getOfferAvgPrice(data).then(response => {
          let avg_list = response.data.avPrice1 || []
          let result = []
          avg_list.forEach(item => {
            let find = result.filter(d => d.year == item.year)
            if (find.length > 0) {
              find[0].list.push(item)
              find[0].list.sort((a, b) => a.month === -1 ? 1 : a.month - b.month);
            } else {
              let arr = []
              arr.push(item)
              result.push({
                year: item.year,
                list: arr
              });
            }
          });
          this.avgTableData = result

          let del_avg_list = response.data.avPrice2 || []
          let result2 = []
          let maps = {}
          del_avg_list.forEach(item => {
            const idx = maps[item.dealer];
            if (idx != undefined && idx >= 0) {
              const o_item = result2[idx] || {}
              result2.splice(idx, 1, {
                ...o_item,
                dealer: item.dealer,
                [`avg_price_${item.year}`]: item.avgPrice,
                [`${item.year}`]: item
              });
            } else {
              maps[item.dealer] = result2.length
              result2.push({
                dealer: item.dealer,
                [`avg_price_${item.year}`]: item.avgPrice,
                [`${item.year}`]: item
              });
            }
          });
          result2.sort((a, b) => b[`avg_price_${endYear}`] - a[`avg_price_${endYear}`])
          // console.log(result2)
          this.delAvgTableData = result2

          let swatch_avg_list = response.data.swatchPrice || []
          let result3 = []
          swatch_avg_list.forEach(item => {
            let find = result3.filter(d => d.year == item.year && d.swatch == item.swatch)
            if (find.length > 0) {
              let index = find[0].list.findIndex(d => d.month == item.month)
              if (index <= -1) {
                find[0].list.push(item)
                find[0].total = item.month == -1 ? item.totalPrice : 0
                find[0].list.sort((a, b) => a.month === -1 ? 1 : a.month - b.month)
                // console.log(find[0].list)
              }
            } else {
              let arr = []
              arr.push(item)
              result3.push({
                year: item.year,
                swatch: item.swatch,
                total: item.month == -1 ? item.totalPrice : 0,
                list: arr
              });
            }
          });
          result3.sort((a, b) => a.year === b.year ? b.total - a.total : b.year - a.year);
          // console.log(result3)
          this.swatchAvgTableData = result3

          this.avgLoading = false
          this.searchForm.brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
        }).catch(() => {
          this.avgLoading = false
        })
      },

      initCharts(list, type) {
        let circleData = []

        for (const item of list) {
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }

        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
              }
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }

        if (type == '11') {
          this.circleOption11 = circle
        } else if (type == '10') {
          this.circleOption10 = circle
        } else if (type == '9') {
          this.circleOption9 = circle
        } else if (type == '8') {
          this.circleOption8 = circle
        } else if (type == '7') {
          this.circleOption7 = circle
        } else if (type == '71') {
          this.circleOption71 = circle
        } else if (type == '6') {
          this.circleOption6 = circle
        } else if (type == '5') {
          this.circleOption5 = circle
        } else if (type == '4') {
          this.circleOption4 = circle
        } else if (type == '3') {
          this.circleOption3 = circle
        } else if (type == '2') {
          this.circleOption2 = circle
        } else {
          this.circleOption = circle
        }
      },

      getGroupList() {
        getGroupReport().then(response => {
          const arr = []
          for (const item of response.data) {
            if (item.nature === 0) {
              arr.push(item)
            }
          }
          this.groupList = arr
        })
      },

      // 弹窗信息
      seeBjDetail(row) {
        this.orderVisible2 = true

        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          group: this.searchForm.group,
          keyword: this.searchForm.search,
          startTime: startTime,
          endTime: endTime,
          type: 1,
          name: row.name,
          userid: this.user.dUserid
        }
        this.orderLoading2 = true
        this.viewTitle2 = ''
        this.orderList2 = []
        getOfferCraftsAnalysisDetail(data).then(response => {
          const data = response.data || []
          this.orderList2 = data
          this.orderLoading2 = false
          this.viewTitle2 = row.name + ' - 拆单详情 (共 ' + this.orderList2.length + ' 单)'
        }).catch(() => {
          this.orderLoading2 = false
        })
      },

      view(row, type) {
        this.viewType = this.getTypeViewName(type)
        this.viewTitle = row.name + (type == '1' || type == '2' ? '报价' : '') + '详情'
        this.viewName = row.name
        if (this.searchForm.time.length === 2) {
          this.viewTime = this.searchForm.time[0] + ' 至 ' + this.searchForm.time[1]
        } else {
          this.viewTime = 'N/A'
        }
        this.viewAmount = row.priceTotal
        this.viewVisible = true
        this.viewPage.currentPage = 1
        this.viewPage.pageSize = 10
        this.getDetailData()
      },

      getDetailData() {
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        let type = this.getViewNameType()
        if (type == '99') {
          this.$message({
            type: 'error',
            message: '查看类型错误！'
          })
          return
        }
        this.viewLoading = true
        const data = {
          startTime: startTime,
          endTime: endTime,
          type: type,
          page: this.viewPage.currentPage,
          limit: this.viewPage.pageSize,
          group: this.searchForm.group,
          userid: this.user.dUserid
        }
        this.viewData = []
        this.viewPage.total = 0
        getOfferAnalysisOrderList(data).then(response => {
          this.viewData = response.data
          this.viewPage.total = response.total
          this.viewLoading = false
        }).catch(() => {
          this.viewLoading = false
        })
      },

      getTypeViewName(type) {
        let viewType = '品类'
        switch (type) {
          case '11':
            viewType = '报价人员业绩'
            break;
          case '10':
            viewType = '拆单人员业绩'
            break;
          case '8':
            viewType = '报价金额组成'
            break;
          case '7':
            viewType = '报价天数'
          case '71':
            viewType = '报价天数'
            break;
          case '6':
            viewType = '订单类型金额'
            break;
          case '5':
            viewType = '订单类型数量'
            break;
          case '4':
            viewType = '金额组成'
            break;
          case '3':
            viewType = '更改单'
            break;
          case '2':
            viewType = '工艺'
            break;
          case '1':
            viewType = '品类'
            break;
          default:
            break;
        }
        return viewType
      },

      getViewNameType() {
        let type = 99
        if (this.viewName === '贴皮') {
          type = 1
        } else if (this.viewName === '混油') {
          type = 2
        } else if (this.viewName === '免漆板') {
          type = 3
        } else if (this.viewName === '其他品类') {
          type = 4
        } else if (this.viewName === '墙板') {
          type = 5
        } else if (this.viewName === '柜体') {
          type = 6
        } else if (this.viewName === '门类') {
          type = 7
        } else if (this.viewName === '配件') {
          type = 8
        } else if (this.viewName === '铝材') {
          type = 9
        } else if (this.viewName === '其他工艺') {
          type = 10
        } else if (this.viewName === '加价') {
          type = 11
        } else if (this.viewType !== '金额组成' && this.viewName === '优惠金额') {
          type = 12
        } else if (this.viewType === '金额组成' && this.viewName === '工厂承担') {
          type = 13
        } else if (this.viewType === '金额组成' && this.viewName === '客户承担') {
          type = 14
        } else if (this.viewType === '金额组成' && this.viewName === '设计承担') {
          type = 15
        } else if (this.viewType === '金额组成' && (this.viewName === '优惠及退款' || this.viewName === '优惠金额')) {
          type = 16
        } else if (this.viewType === '金额组成' && this.viewName === '退款金额') {
          type = 17
        } else if (this.viewName === '客户承担') {
          type = 91
        } else if (this.viewName === '工厂承担') {
          type = 92
        } else if (this.viewName === '设计承担') {
          type = 93
        } else if (this.viewName === '退款金额') {
          type = 94
        }
        return type;
      },

      handleSizeChange(val) {
        this.viewPage.pageSize = val
        this.getDetailData()
      },
      handleCurrentChange(val) {
        this.viewPage.currentPage = val
        this.getDetailData()
      },

      openDetails(row) {
        if (row.orderId.length > 36) {
          this.$router.push({
            path: '/work/order/' + row.orderId.substring(0, 36),
            query: {
              data: row.orderId.substring(37)
            }
          })
        } else {
          this.$router.push({ path: '/work/order/' + row.orderId.substring(0, 36) })
        }
        this.viewVisible = false
        this.dialogVisible = false
        this.orderVisible2 = false
      },

      exportExcel() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          let type = this.getViewNameType()
          const data = {
            group: this.searchForm.group,
            startTime: startTime,
            endTime: endTime,
            type: type,
            name: this.viewName,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          exportOfferAnalysisOrderListExcel(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

      exportExcelAll() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            group: this.searchForm.group,
            startTime: startTime,
            endTime: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          excelOfferCraftsAnalysis(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

      exportExcelOfferTime() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            group: this.searchForm.group,
            startTime: startTime,
            endTime: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          excelOfferTime(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

      exportExcelOfferAvgPrice(type) {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startYear = ''
          let endYear = ''
          let brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
          if (this.searchForm.years !== null && this.searchForm.years.length === 2) {
            startYear = this.searchForm.years[0]
            endYear = this.searchForm.years[1]
          }
          const data = {
            group: this.searchForm.group,
            startYear: startYear,
            endYear: endYear,
            type: type,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/api/excelOfferAvgPrice',
            params: data,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => { // 处理返回的文件流
            this.excelLoading = false
            const blob = new Blob([res.data]);
            const fileName = startYear + '~' + endYear + '年度' + brand + '品牌家装正单' + (type == 2 ? '经销商' : '') +
              '报价均值统计表.xlsx';
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }).catch(err => {
            this.excelLoading = false
            this.$message({
              type: 'error',
              message: '导出失败，请稍候再试'
            })
          });
        }
      },

    }
  }
</script>

<style scoped>

</style>
